import { Component, OnInit } from '@angular/core';
import { ApiService, Calculadora, ITests } from '../../servicio/api.service';

@Component({
  selector: 'app-parametros',
  templateUrl: './parametros.component.html',
  styleUrls: ['../../theme.scss']
})
export class ParametrosComponent implements OnInit {

  app: Calculadora;
  metaIndex: any;

  constructor(public api: ApiService) {
    this.app = api.app;
    this.metaIndex = api.metaIndex;
  }

  ngOnInit() {
  }

  isGoal(index) {
    if (this.metaIndex) {
      return index === this.metaIndex.meta_1 || index === this.metaIndex.meta_2 || index === this.metaIndex.meta_3;
    }
    return false;
  }

}
